import { UserException } from '@/domain/user/exception/UserException'

export class CannotDeleteUserException extends UserException {
}
